import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <div className="contact-container">

      <div className="contact-header">
        <h1>Contact REACH AI</h1>
        <p>
          We value your feedback and inquiries. Please feel free to reach out to us.
        </p>
      </div>

      <div className="contact-card">
        <h2>📧 Email Support</h2>
        <p>
          For questions, suggestions, or support related to REACH AI,
          contact us at:
        </p>

        <a
          href="mailto:btechprojectgrp@gmail.com"
          className="contact-email"
        >
          btechprojectgrp@gmail.com
        </a>

        <p className="contact-note">
          We aim to respond within 24–48 hours.
        </p>
      </div>

      <div className="contact-footer">
        <p>
          REACH AI – Empowering Community Health Through Technology.
        </p>
      </div>

    </div>
  );
}

export default Contact;